import { Outlet } from "react-router";
import { AuthRevalidator } from "@/components/AuthRevalidator/AuthRevalidator";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { MsalAuthManager } from "@/msal";
import { EntraAuthSync } from "@/msal/EntraAuthSync";

export const RootLayout = () => {
  return (
    <MsalAuthManager>
      <NuqsAdapter>
        <EntraAuthSync />
        <AuthRevalidator />
        <Outlet />
      </NuqsAdapter>
    </MsalAuthManager>
  );
};
